<template>
  <div class="projects container-fluid">
    <div class="col-10 text">
      <h2>
        NIEPOWTARZALNY CHARAKTER, KWINTESENCJA NATURY I CIĘŻKA PRACA TO ATRYBUTY
        KOLEKCJI DWORSKIEJ. PO WIELU LATACH PRACY, WYBORÓW I DOŚWIADCZENIA
        PREZENTUJEMY NAJBARDZIEJ WYJĄTKOWĄ KOLEKCJE NASZYCH DESEK.
      </h2>
      <p>
        Jeżeli Twoim marzeniem jest podłoga rustykalna do salonu, to być może
        mamy klucz do jego spełnienia. Oferowana przez nasz wrocławski zespół
        Kolekcja Dworska to deski stworzone przy największym nakładzie naszej
        pracy i czasu. Każda z nich poddawany jest wielu operacjom, które są
        wykonywane ręcznie. Wszystkie deski są niepowtarzalne, wzory zostały
        dokładnie wyselekcjonowane i doszlifowane w każdym szczególe. Podłogi
        pałacowe z Kolekcji Dworskiej dają pewność, że wnętrze nabierze
        charakteru. To po prostu najlepszy wybór dla każdego salonu.
      </p>
      <p>
        Ich wygląd niemal natychmiast kojarzy się z eleganckim wnętrzem pałacu.
        Chcemy podzielić się z Tobą wrażeniem elegancji i luksusu, które
        towarzyszy naszym wyrobom. Proponowane kolekcje to także wybór na lata –
        drewno dębowe jest wyjątkowo trwałe i odporne na zniszczenia, a jego
        naturalne piękno sprawia, że zawsze będzie wyglądało świetnie.
      </p>
    </div>
    <div
      v-scrollanimation
      class="image col-10 col-sm-5 col-md-4 col-xl-3"
      v-for="(image, index) in media"
      :key="index"
      @click="openGallery(index)"
      :style="{
        width: 'auto',
        height: '17rem'
      }"
    >
      <img v-lazy="image.src || image.thumb" @click="openGallery(index)" />
      <h3>{{ image.caption }}</h3>
    </div>

    <LightBox
      ref="lightbox"
      :media="media"
      :show-caption="true"
      :show-light-box="false"
    />
  </div>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import Images from "./aulic.js";
import LightBox from "vue-image-lightbox";
export default {
  data: function() {
    return {
      index: null,
      media: Images
    };
  },
  methods: {
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    }
  },

  components: {
    LightBox
  }
};
</script>
<style scoped>
.text {
  text-align: center;
  margin-top: 2%;
}
.projects {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.image {
  height: auto;
  display: inline-block;
  position: relative;
  transition: 0.3s;
  margin: 1%;
}

.image img {
  width: 100%;
  height: 100%;
  transition: 0.3s;
  border-radius: 4px;
}

.image:hover img {
  filter: blur(2px) brightness(60%);
  box-shadow: 0 0 16px rgb(32, 28, 28);
  cursor: pointer;
}

.image :not(img) {
  position: absolute;
  z-index: 1;
  width: 90%;
  top: 50%;

  left: 5%;
  color: #fff;
  opacity: 0;
  transition: 0.3s;
}

.image:hover :not(img) {
  cursor: pointer;
  opacity: 1;
}
</style>
